import { render, staticRenderFns } from "./CouponPop.vue?vue&type=template&id=3ff2774a&scoped=true"
import script from "./CouponPop.vue?vue&type=script&lang=js"
export * from "./CouponPop.vue?vue&type=script&lang=js"
import style0 from "./CouponPop.vue?vue&type=style&index=0&id=3ff2774a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2774a",
  null
  
)

export default component.exports